module.exports = __webpack_public_path__ + "img/nodejs.7486b0a4.svg";